// Tiny dependency-free lightbox for blog galleries (galleryLayout: lightbox).
// Progressive enhancement: thumbnails are <a href> to the full image, so the
// gallery works with JS disabled; this script intercepts clicks to open a modal.

export function nextIndex(i, dir, len) {
  return (i + dir + len) % len;
}

function buildModal(doc) {
  const root = doc.createElement('div');
  root.className = 'blog-lightbox';
  root.setAttribute('role', 'dialog');
  root.setAttribute('aria-modal', 'true');
  root.setAttribute('aria-label', 'Image viewer');
  root.hidden = true;
  root.innerHTML =
    '<button class="blog-lightbox__close" aria-label="Close">×</button>' +
    '<button class="blog-lightbox__nav blog-lightbox__nav--prev" aria-label="Previous">‹</button>' +
    '<img class="blog-lightbox__img" alt="">' +
    '<button class="blog-lightbox__nav blog-lightbox__nav--next" aria-label="Next">›</button>';
  doc.body.appendChild(root);
  return root;
}

export function initBlogLightbox(doc = document) {
  const galleries = [...doc.querySelectorAll('.article-block--gallery[data-lightbox]')];
  if (!galleries.length) return;

  const modal = buildModal(doc);
  const img = modal.querySelector('.blog-lightbox__img');
  let items = [];
  let idx = 0;
  let lastFocus = null;

  const background = () => [...doc.body.children].filter((el) => el !== modal);
  const focusables = () => [...modal.querySelectorAll('button:not([disabled])')];

  const show = () => { img.src = items[idx].href; img.alt = items[idx].dataset.alt || ''; };
  const open = (group, i) => {
    items = group; idx = i; lastFocus = doc.activeElement;
    show(); modal.hidden = false;
    background().forEach((el) => { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); });
    modal.querySelector('.blog-lightbox__close').focus();
  };
  const close = () => {
    modal.hidden = true;
    background().forEach((el) => { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); });
    if (lastFocus) lastFocus.focus();
  };
  const move = (dir) => { idx = nextIndex(idx, dir, items.length); show(); };

  galleries.forEach((g) => {
    const links = [...g.querySelectorAll('a.gallery-thumb')];
    links.forEach((a, i) => a.addEventListener('click', (e) => { e.preventDefault(); open(links, i); }));
  });

  modal.querySelector('.blog-lightbox__close').addEventListener('click', close);
  modal.querySelector('.blog-lightbox__nav--prev').addEventListener('click', () => move(-1));
  modal.querySelector('.blog-lightbox__nav--next').addEventListener('click', () => move(+1));
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  doc.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') move(+1);
    else if (e.key === 'ArrowLeft') move(-1);
    else if (e.key === 'Tab') {
      const f = focusables();
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
}

// Self-init in the browser only; guarded so the node test can import nextIndex.
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBlogLightbox());
  } else {
    initBlogLightbox();
  }
}
